// @flow

import _ from 'lodash';

import type { EnrollmentPeriodType } from 'web-core/types/enrollment';

const nearStrideCutoff = (enrollmentPeriod: EnrollmentPeriodType) => {
  const now = +new Date();
  const difference = new Date(enrollmentPeriod.stride_end_date).getTime() - now;
  return difference > 0 && difference <= 1000 * 60 * 60 * 24 * 5; // 5 day buffer
};

const missedStrideCutoff = (enrollmentPeriod: EnrollmentPeriodType) => {
  const now = +new Date();
  const strideEndDate = new Date(enrollmentPeriod.stride_end_date).getTime();
  const officialEndDate = new Date(enrollmentPeriod.official_end_date).getTime();
  return strideEndDate < now && officialEndDate > now;
};

class EnrollmentPeriodModel {
  effectiveDate: Date;
  nextEffectiveDate: Date;
  enrollmentPeriod: EnrollmentPeriodType;
  showCutoffNear: boolean;
  showCutoffMissed: boolean;
  isOep: boolean;
  isPeriodEnd: boolean;
  justMissedCutoff: boolean;

  constructor(enrollmentPeriod: EnrollmentPeriodType, nextEnrollmentPeriod: EnrollmentPeriodType) {
    const diffFromStrideEnd = new Date() - new Date(enrollmentPeriod.stride_end_date);
    const diffFromOfficialStart = new Date() - new Date(enrollmentPeriod.official_start_date);

    this.effectiveDate = enrollmentPeriod.effective_date;
    this.nextEffectiveDate = _.get(
      nextEnrollmentPeriod,
      'effective_date',
      _.get(enrollmentPeriod, 'effective_date'),
    );
    this.enrollmentPeriod = enrollmentPeriod;
    this.showCutoffNear = nearStrideCutoff(enrollmentPeriod);
    this.showCutoffMissed = missedStrideCutoff(enrollmentPeriod);
    this.isOep = enrollmentPeriod.period_type === 'oep';
    this.isPeriodEnd =
      !nextEnrollmentPeriod || enrollmentPeriod.period_type !== nextEnrollmentPeriod.period_type;
    // 1 hour after cutoff
    this.justMissedCutoff =
      (diffFromStrideEnd < 1000 * 60 * 60 && diffFromStrideEnd > 0) ||
      (diffFromOfficialStart < 1000 * 60 * 60 && diffFromOfficialStart > 0);
  }
}

export default EnrollmentPeriodModel;
